type SectionHeadingProps = {
  kicker?: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
  tone?: 'light' | 'dark';
};

const SectionHeading = ({
  kicker,
  title,
  desc,
  align = 'left',
  tone = 'light',
}: SectionHeadingProps) => {
  const isCenter = align === 'center';
  const isDark = tone === 'dark';

  return (
    <div className={`max-w-2xl ${isCenter ? 'mx-auto text-center' : ''}`}>
      {kicker && (
        <span
          className={`mb-3 inline-flex items-center gap-2 text-xs font-label font-medium uppercase tracking-[0.2em] ${
            isDark ? 'text-accent-400' : 'text-primary-600'
          }`}
        >
          <span className={`h-px w-6 ${isDark ? 'bg-accent-400' : 'bg-primary-500'}`} />
          {kicker}
        </span>
      )}
      <h2
        className={`font-heading text-2xl font-semibold leading-snug md:text-4xl ${
          isDark ? 'text-background-50' : 'text-foreground-950'
        }`}
      >
        {title}
      </h2>
      {desc && (
        <p
          className={`mt-4 text-sm leading-relaxed md:text-base ${
            isDark ? 'text-background-200' : 'text-foreground-600'
          }`}
        >
          {desc}
        </p>
      )}
    </div>
  );
};

export default SectionHeading;